import PptxGenJS from "pptxgenjs";

export const slide1 = (pptx: PptxGenJS, data: any) => {
    const slide = pptx.addSlide();
    console.log({ data });

    slide.addImage({
        path: '/Access-Holdings-Logo.jpg',
        x: 0.5,
        y: 0.2,
        w: 1.3,
        h: 0.45
    });

    // Title
    slide.addText("How to Read This Report", {
        x: 0.5,
        y: 0.8,
        w: 7.27,
        h: 0.5,
        fontSize: 22,
        bold: true,
        color: '000000'
    });

    // 1. Purpose of This Report
    slide.addText("Purpose of This Report", {
        x: 0.5,
        y: 1.5,
        w: 7.27,
        h: 0.3,
        fontSize: 14,
        bold: true,
        color: '000000'
    });

    slide.addShape('rect', {
        x: 0.5, y: 1.9, w: 7.27, h: 0.7,
        fill: { color: 'F8F8F8' },
        line: { color: 'E0E0E0', width: 1 }
    });
    slide.addText("This report summarises multi-rater feedback to support your development. This is a developmental tool, not a performance evaluation.", {
        x: 0.7, y: 1.9, w: 6.87, h: 0.7,
        fontSize: 11,
        color: '404040',
        valign: 'middle'
    });

    // 2. Understanding Your Scores
    slide.addText("Understanding Your Scores", {
        x: 0.5,
        y: 3.0,
        w: 7.27,
        h: 0.3,
        fontSize: 14,
        bold: true,
        color: '000000'
    });

    slide.addShape('rect', {
        x: 0.5, y: 3.4, w: 7.27, h: 1.2,
        fill: { color: 'F8F8F8' },
        line: { color: 'E0E0E0', width: 1 }
    });

    // Green bullet
    slide.addShape('rect', { x: 0.75, y: 3.6, w: 0.08, h: 0.08, fill: { color: '4CAF50' }, line: { type: 'none' } });
    slide.addText("Scores from 4.0 and above generally indicate strong, consistent behaviour.", {
        x: 0.95, y: 3.55, w: 6.6, h: 0.2,
        fontSize: 11, color: '404040'
    });

    // Orange bullet
    slide.addShape('rect', { x: 0.75, y: 3.9, w: 0.08, h: 0.08, fill: { color: 'FF9800' }, line: { type: 'none' } });
    slide.addText("Scores between 3.0 - 3.9 show steady performance with room to grow.", {
        x: 0.95, y: 3.85, w: 6.6, h: 0.2,
        fontSize: 11, color: '404040'
    });

    // Red bullet
    slide.addShape('rect', { x: 0.75, y: 4.2, w: 0.08, h: 0.08, fill: { color: 'F44336' }, line: { type: 'none' } });
    slide.addText("Scores below 3.0 may reflect areas for development.", {
        x: 0.95, y: 4.15, w: 6.6, h: 0.2,
        fontSize: 11, color: '404040'
    });

    // 3. Understanding Differences
    slide.addText("Understanding Differences", {
        x: 0.5,
        y: 5.0,
        w: 7.27,
        h: 0.3,
        fontSize: 14,
        bold: true,
        color: '000000'
    });

    slide.addShape('rect', {
        x: 0.5, y: 5.4, w: 7.27, h: 1.2,
        fill: { color: 'F8F8F8' },
        line: { color: 'E0E0E0', width: 1 }
    });

    // Blue bullets
    const diffsY = [5.6, 5.9, 6.2];
    const diffTexts = [
        "If others score you higher: They see strengths you may under-recognise.",
        "If you score yourself higher: Expectations or visibility may differ.",
        "If groups disagree: It is normal; each experiences your work differently."
    ];

    diffTexts.forEach((text, i) => {
        slide.addShape('rect', { x: 0.75, y: diffsY[i] + 0.05, w: 0.08, h: 0.08, fill: { color: '00BCD4' }, line: { type: 'none' } });
        slide.addText(text, {
            x: 0.95, y: diffsY[i], w: 6.6, h: 0.2,
            fontSize: 11, color: '404040'
        });
    });

    // 4. Understanding the Global Norm
    slide.addText("Understanding the Global Norm", {
        x: 0.5,
        y: 7.0,
        w: 7.27,
        h: 0.3,
        fontSize: 14,
        bold: true,
        color: '000000'
    });

    slide.addShape('rect', {
        x: 0.5, y: 7.4, w: 7.27, h: 0.5,
        fill: { color: 'F8F8F8' },
        line: { color: 'E0E0E0', width: 1 }
    });
    slide.addText("This reflects the results from Access Holdings population completing the same assessment.", {
        x: 0.7, y: 7.4, w: 6.87, h: 0.5,
        fontSize: 11,
        color: '404040',
        valign: 'middle'
    });

    // Footer
    const candidateName = data?.candidateName || 'Jane Doe';
    slide.addText(`360-Degree Feedback Individual Report for ${candidateName}`, {
        x: 0,
        y: 11.2,
        w: 7.8,
        h: 0.3,
        fontSize: 9,
        color: '666666',
        align: 'center'
    });

    // slide.addText("2", {
    //     x: 7.8,
    //     y: 11.2,
    //     w: 0.4,
    //     h: 0.3,
    //     fontSize: 9,
    //     color: '666666',
    //     align: 'center'
    // });
};
